import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, Output, ViewEncapsulation } from '@angular/core';
import { ReportAttachment } from '../../../app/interfaces/report/report-attachment';
import { Gallery, GalleryItem, GalleryRef, ImageItem, VideoItem } from 'ng-gallery';
import { Subject } from 'rxjs';
import { TrackAndTraceService } from '../../../app/services/reports/track-and-trace.service';

@Component({
  selector: 'fury-attachments',
  templateUrl: './attachment.component.html',
  styleUrls: ['./attachment.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class AttachmentComponent implements OnDestroy, AfterViewInit {

  @Input() attachments: ReportAttachment[] = [];
  @Input() type: 'report' | 'handling' = 'report';
  @Input() reportUniqueId: string = null;

  @Output() destroy: EventEmitter<boolean> = new EventEmitter<boolean>();

  public galleryMedia: GalleryItem[] = [];
  public galleryReportRef: GalleryRef = null;
  public isDownloading: boolean = false;

  private destroy$: Subject<null> = new Subject<null>();

  constructor(
    private trackAndTraceService: TrackAndTraceService,
    private cd: ChangeDetectorRef,
    public gallery: Gallery,
  ) {
    this.galleryReportRef = this.gallery.ref('attachments-gallery');
  }

  ngAfterViewInit(): void {
    this.attachments.forEach((item: ReportAttachment): void => {
      if (item.type === 'video') {
        this.galleryMedia.push(new VideoItem({
          src: <any>[
            {
              url: item.src + '?ngsw-bypass=true',
              type: item.mime,
            }
          ],
          thumb: '/assets/img/video.jpg'
        }));
      } else if (item.type === 'image') {
        this.galleryMedia.push(new ImageItem({
          src: item.src,
          thumb: item.thumb,
        }));
      }
    });
    this.galleryReportRef.load(this.galleryMedia);
  }

  downloadAttachment(attachmentId: number): void {
    this.isDownloading = true;
    this.cd.detectChanges();

    if (this.type === 'handling') {
      this.trackAndTraceService.downloadHandlingAttachment(this.reportUniqueId, attachmentId);
    } else {
      this.trackAndTraceService.downloadAttachment(this.reportUniqueId, attachmentId);
    }

    setTimeout((): void => {
      this.isDownloading = false;
      this.cd.detectChanges();
    }, 1500);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
